//Importaciones
import React, { useContext, useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { enum__ComponentType } from '../../../../../../common/Dictionaries';
import { useDispatch, useSelector } from 'react-redux';
import { action_setCompareContracts_ChartData, action_setCompareContracts_ChartDataBase, action_setCompareContracts_ChartData_Structure, action_setCompareContracts_ContractFilters, action_setCompareContracts_ContractFilters_Selected_All, action_setCompareContracts_Contratos, action_setCompareContracts_Contratos_Filtred, action_setCompareContracts_FireGetData, action_setCompareContracts_OPFData, action_setCompareContracts_SegmentList } from '../../../../../../reducers/actions/KPI/compareContractsActions';
import Picker from '../../../../../Common/Picker';
import "../../../../../../styles/css/DropDownCheckbox.css";
import { isNullUndefined } from '../../../../../../common/Helpers';
import MainAppContext from '../../../../../../MainAppContext';
import { getBoardComponentInfoRecursiveValues } from '../../../../../../services/sKPI/board.service';
import { __OBJECT_STRUCTURE_BoardFilters } from '../../../../../../common/ObjectStructures/sKPI';
import i18next from 'i18next';
import { action_setPortfolio_Report_ElementIds } from '../../../../../../reducers/actions/SITE/portfolioActions';
import Loading from '../../../../../Templates/Site/Loading';

function CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE(props) {
    //Helpers
    const { t } = useTranslation();
    const dispatch = useDispatch();
	const contextSite = useContext(MainAppContext);

    const { 
      inputParam_HideHeader = false,
      inputParam_ComponentContent = null,
      inputParam_BoardId = null,
      inputParam_UseFake = false,
    } = props;

	const { 
		_contratosParaGrafico: selectedContracts,
		_pilarSeleccionado: pilarSeleccionado,
		_filtrosContratos: filtrosContratos,
		_filtrosContratosBase: filtrosContratosBase,
		_contratosBase: contratosBase,
		_filtrosContratosSeleccionados: filtrosContratosSeleccionados,
		_filtrosConfiguracion: filtrosConfiguracion,
	} = useSelector((state) => state.compareContractsScope);

	
    const [defaultSelectedFiltersBinded, setDefaultSelectedFiltersBinded] = useState(true);


	const hasSelectedFilters = (selectedFilters) => {
		return Object.keys(filtrosConfiguracion).some(filterKey =>
			!isNullUndefined(selectedFilters?.[`l_filter_${filtrosConfiguracion[filterKey].contractProp}`]) &&
			selectedFilters[`l_filter_${filtrosConfiguracion[filterKey].contractProp}`].length > 0
		);
	};

	const filterContractsBySelection = (contracts, selectedFilters) => {
		let result = [...contracts];

		Object.keys(filtrosConfiguracion).forEach(filterKey => {
			const selectedItems = selectedFilters?.[`l_filter_${filtrosConfiguracion[filterKey].contractProp}`];

			if (!isNullUndefined(selectedItems) && selectedItems.length > 0) {
				const { contractProp, selectedItemProp } = filtrosConfiguracion[filterKey];
				const selectedValues = selectedItems.map(x => x[selectedItemProp]);

				result = result.filter(contract =>
					selectedValues.includes(contract[contractProp])
				);
			}
		});

		return result;
	};

	const buildAvailableFilters = (baseFilters, baseContracts, selectedFilters) => {
		const availableFilters = {};

		Object.keys(filtrosConfiguracion).forEach(filterKey => {
			const { contractProp, filterItemProp } = filtrosConfiguracion[filterKey];

			const selectedFiltersWithoutCurrent = {
				...selectedFilters,
				[`l_filter_${filtrosConfiguracion[filterKey].contractProp}`]: []
			};

			const compatibleContracts = filterContractsBySelection(
				baseContracts,
				selectedFiltersWithoutCurrent
			);

			const availableValues = new Set(
				compatibleContracts
					.map(contract => contract[contractProp])
					.filter(x => !isNullUndefined(x))
			);

			availableFilters[`l_filter_${filtrosConfiguracion[filterKey].contractProp}`] = (baseFilters?.[`l_filter_${filtrosConfiguracion[filterKey].contractProp}`] ?? []).filter(item =>
				availableValues.has(item[filterItemProp])
			);
		});

		return availableFilters;
	};

	const cleanInvalidSelectedFilters = (selectedFilters, availableFilters) => {
		const cleaned = {};

		Object.keys(filtrosConfiguracion).forEach(filterKey => {
			const { selectedItemProp } = filtrosConfiguracion[filterKey];

			const validValues = new Set(
				(availableFilters?.[`l_filter_${filtrosConfiguracion[filterKey].contractProp}`] ?? []).map(x => x[selectedItemProp])
			);

			cleaned[`l_filter_${filtrosConfiguracion[filterKey].contractProp}`] = (selectedFilters?.[`l_filter_${filtrosConfiguracion[filterKey].contractProp}`] ?? []).filter(item =>
				validValues.has(item[selectedItemProp])
			);
		});

		return cleaned;
	};

	const recalculateContractsAndFilters = (
		baseContracts,
		baseFilters,
		selectedFilters
	) => {
		const firstAvailableFilters = buildAvailableFilters(
			baseFilters,
			baseContracts,
			selectedFilters
		);

		const cleanedSelectedFilters = cleanInvalidSelectedFilters(
			selectedFilters,
			firstAvailableFilters
		);

		const finalFilteredContracts = filterContractsBySelection(
			baseContracts,
			cleanedSelectedFilters
		);

		const finalAvailableFilters = buildAvailableFilters(
			baseFilters,
			baseContracts,
			cleanedSelectedFilters
		);

		return {
			filteredContracts: finalFilteredContracts,
			availableFilters: finalAvailableFilters,
			cleanedSelectedFilters
		};
	};

	const markCheckedItems = (availableFilters, selectedFilters) => {
		const result = {};

		Object.keys(availableFilters ?? {}).forEach(filterKey => {
			const selectedItemProp = filtrosConfiguracion?.[filterKey]?.selectedItemProp ?? "value";

			const selectedValues = new Set(
				(selectedFilters?.[filterKey] ?? []).map(x => x[selectedItemProp])
			);

			result[filterKey] = (availableFilters?.[filterKey] ?? []).map(item => ({
				...item,
				checked: selectedValues.has(item[selectedItemProp])
			}));
		});

		return result;
	};

	const onChangeFilter = (currentNode, selectedNodes, filterType) => {
		dispatch(action_setCompareContracts_FireGetData(true));
		dispatch(action_setCompareContracts_Contratos([]));
		dispatch(action_setPortfolio_Report_ElementIds([]));

		const normalizedSelectedNodes = selectedNodes ?? [];

		const newSelectedFilters = {
			...filtrosContratosSeleccionados,
			[filterType]: normalizedSelectedNodes
		};

		const {
			filteredContracts,
			availableFilters,
			cleanedSelectedFilters
		} = recalculateContractsAndFilters(
			contratosBase,
			filtrosContratosBase,
			newSelectedFilters
		);

		const availableFiltersWithChecked = markCheckedItems(
			availableFilters,
			cleanedSelectedFilters
		);

		dispatch(action_setCompareContracts_ContractFilters_Selected_All(cleanedSelectedFilters));
		dispatch(action_setCompareContracts_ContractFilters(availableFiltersWithChecked));
		dispatch(action_setCompareContracts_Contratos_Filtred(filteredContracts));

		setDefaultSelectedFiltersBinded(false);
	};

	const filterContracts = async () => {
		const selectedFilters = filtrosContratosSeleccionados ?? {};

		const filteredContracts = hasSelectedFilters(selectedFilters)
			? filterContractsBySelection(contratosBase, selectedFilters)
			: [...contratosBase];

		dispatch(action_setCompareContracts_Contratos_Filtred(filteredContracts));

		if (!hasSelectedFilters(selectedFilters)) {
			dispatch(action_setCompareContracts_Contratos([]));
			dispatch(action_setPortfolio_Report_ElementIds([]));
			
			dispatch(action_setCompareContracts_ChartData(null));
			dispatch(action_setCompareContracts_ChartDataBase(null));
			dispatch(action_setCompareContracts_OPFData(null));
			dispatch(action_setCompareContracts_FireGetData(false));
			return;
		}

		dispatch(action_setCompareContracts_Contratos(filteredContracts));
		dispatch(action_setPortfolio_Report_ElementIds(filteredContracts.map(x => x.elementId)));

		try {
			setDefaultSelectedFiltersBinded(true);

			let filter = __OBJECT_STRUCTURE_BoardFilters("element");
			filter.l_codes = filteredContracts.map(x => x.elementId.toString());

			let serviceResponse = await getBoardComponentInfoRecursiveValues(
				filter,
				inputParam_BoardId,
				enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_CHART,
				null,
				null,
				contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
				contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate,
				contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate,
				contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId
			);

			if (serviceResponse.data.succeeded) {
				const allDataToCompare = serviceResponse.data.data[0].items;
				const opfData = serviceResponse.data.data[0].items.find(x => x.name === 'OPF');
				let contractSeries = [];
				//let contractCategories = [];
				const contractCategories = opfData.l_vals.filter(x => x.elementId === 0).map(x => x.periodId);

				filteredContracts.forEach(selectedContract => {
					let contractSerie = {};
					contractSerie.name = `${selectedContract.contractCode} - ${selectedContract.supplierName}`;
					contractSerie.data = [];
					contractSerie.isDashed = 0;

					allDataToCompare.forEach(unmanipulatedDataItemWithMergedSeries => {
						if (pilarSeleccionado.scopeId === unmanipulatedDataItemWithMergedSeries.id) {
							/*if (
								unmanipulatedDataItemWithMergedSeries.l_vals.length > 0 &&
								contractCategories.length === 0
							) {
								contractCategories =
									unmanipulatedDataItemWithMergedSeries.l_vals
										.map(x => x.periodId.toString())
										.filter((value, index, self) => self.indexOf(value) === index);
							}*/

							unmanipulatedDataItemWithMergedSeries.l_vals.forEach(unmanipulatedLValItem => {
								if (unmanipulatedLValItem.elementId === selectedContract.elementId) {
									contractSerie.data.push(
										!isNullUndefined(unmanipulatedLValItem.scopeValue)
											//? parseFloat(unmanipulatedLValItem.scopeValue.toFixed(2)).toLocaleString(i18next.language)
											//? parseFloat(unmanipulatedLValItem.scopeValue.toFixed(0)).toLocaleString(i18next.language)
											? Math.round(unmanipulatedLValItem.scopeValue).toLocaleString(i18next.language)
											: unmanipulatedLValItem.scopeValue
									);
								}
							});
						}
					});

					contractSeries.push(contractSerie);
				});

				if (pilarSeleccionado.scopeId === 0) {
					let contractSerieOpf = {};
					contractSerieOpf.name = `~ ${pilarSeleccionado.name} ~`;
					contractSerieOpf.data = [];
					contractSerieOpf.isDashed = 5;

					allDataToCompare
						.filter(x => x.name === pilarSeleccionado.name)
						.forEach(unmanipulatedDataItemWithMergedSeries => {
							/*if (
								unmanipulatedDataItemWithMergedSeries.l_vals.length > 0 &&
								contractCategories.length === 0
							) {
								contractCategories =
									unmanipulatedDataItemWithMergedSeries.l_vals
										.map(x => x.periodId.toString())
										.filter((value, index, self) => self.indexOf(value) === index);
							}*/

							unmanipulatedDataItemWithMergedSeries.l_vals.forEach(unmanipulatedLValItem => {
								if (unmanipulatedLValItem.elementId === 0) {
									contractSerieOpf.data.push(
										!isNullUndefined(unmanipulatedLValItem.scopeValue)
											//? parseFloat(unmanipulatedLValItem.scopeValue.toFixed(2)).toLocaleString(i18next.language)
											//? parseFloat(unmanipulatedLValItem.scopeValue.toFixed(0)).toLocaleString(i18next.language)
											? Math.round(unmanipulatedLValItem.scopeValue).toLocaleString(i18next.language)
											: unmanipulatedLValItem.scopeValue
									);
								}
							});
						});

					contractSeries.push(contractSerieOpf);
				}
				dispatch(action_setCompareContracts_ChartData_Structure(serviceResponse?.data?.data[0].items));

				dispatch(action_setCompareContracts_ChartData({contractSeries, contractCategories}));
				dispatch(action_setCompareContracts_ChartDataBase({contractSeries, contractCategories}));
				dispatch(action_setCompareContracts_OPFData(opfData));
				dispatch(action_setCompareContracts_FireGetData(false));
				dispatch(action_setCompareContracts_SegmentList(null))
			}
			else {
				dispatch(action_setCompareContracts_ChartData(null));
				dispatch(action_setCompareContracts_ChartDataBase(null));
				dispatch(action_setCompareContracts_OPFData(null));
				dispatch(action_setCompareContracts_FireGetData(false));
			}
		}
		catch (error) {
			dispatch(action_setCompareContracts_ChartData(null));
			dispatch(action_setCompareContracts_ChartDataBase(null));
			dispatch(action_setCompareContracts_OPFData(null));
			dispatch(action_setCompareContracts_FireGetData(false));
		}
	};

	useEffect(() => {
        function doit() {
			setDefaultSelectedFiltersBinded(true);
			filterContracts();
		}
  
		if (defaultSelectedFiltersBinded === false) {
			doit()
		}
    }, [inputParam_ComponentContent, defaultSelectedFiltersBinded, setDefaultSelectedFiltersBinded]);

    const renderContentDynamic = () => {
      	return  <>
					{
						!isNullUndefined(filtrosContratos) && !isNullUndefined(filtrosConfiguracion) && 
						<Row>
							{
								Object.keys(filtrosConfiguracion).sort((a, b) => filtrosConfiguracion[a].order - filtrosConfiguracion[b].order).map((filterPropKey, index) => (
									<>
										{
											filtrosConfiguracion[filterPropKey].enable === true &&
											<Col key={index}>
												{
													!isNullUndefined(filtrosContratos[`l_filter_${filtrosConfiguracion[filterPropKey].contractProp}`]) &&
													<Picker
														data={ filtrosContratos !== null ? filtrosContratos[`l_filter_${filtrosConfiguracion[filterPropKey].contractProp}`] : [] }
														mode="multiSelect"
														className="dropdown-checkbox"
														isInValid={ false }
														texts={{ placeholder: t('data-lang-lbl-chooses') }}
														onChange={ (currentNode, selectedNodes) => onChangeFilter(currentNode, selectedNodes, `l_filter_${filtrosConfiguracion[filterPropKey].contractProp}`) }
														labelText={ (filtrosConfiguracion[filterPropKey].useDataLang ? t(filtrosConfiguracion[filterPropKey].dataLangKey) : filtrosConfiguracion[filterPropKey].filterName) }
													/>
												}
											</Col>
										}
									</>
								))
							}
						</Row>
					}
				</>
    }

    //Render de componente.
    return (
		<>
			{
				!inputParam_UseFake &&
				<Card className='h-100 mx-2'>
					{
						!inputParam_HideHeader &&
						<Card.Header className="card-header-compact">
								<Card.Title className="d-flex justify-content-between">
									<b>
										{
											(inputParam_ComponentContent !== null) ?
												(inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-group_list_to_select')) :
												t('data-lang-boxname-group_list_to_select')
										}&nbsp;
										{`(${!isNullUndefined(selectedContracts) ? selectedContracts.length : 0})`}
									</b>
									<div className='toolbar d-flex'>

									</div>
								</Card.Title>
						</Card.Header>
					}
					<Card.Body className='h-100 m-0'>
						{ pilarSeleccionado && filtrosContratos && renderContentDynamic() }
						{!(pilarSeleccionado && filtrosContratos) &&
							<Loading
								inputParam_Style={{marginTop: 0}}
								inputParam_Width = '30px'
								inputParam_Height = '30px'
							/>
						}
					</Card.Body>
				</Card>
			}
			{ inputParam_UseFake && renderContentDynamic() }
		</>
    );
}

CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE.propTypes = {
	inputParam_BoardId: PropTypes.number.isRequired,
	inputParam_UseFake: PropTypes.bool.isRequired,
	inputParam_HideHeader: PropTypes.bool.isRequired,
	inputParam_ComponentContent: PropTypes.object.isRequired,
};

export default CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE;